module.exports = __webpack_public_path__ + "img/XPM-alt.721664f7.svg";